import actionTypes from './actionTypes';

const initialState = {
  average: [],
  best: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.GET_RESULTS}_SUCCESS`: {
      return {
        ...state,
        average: action.payload?.average || [],
        best: action.payload?.best || [],
      };
    }
    default: {
      return state;
    }
  }
};
